// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const sailboat = defineModel({
  id: "sailboat",
  batchId: "future",
  name: "Sailboat",
  tags: ["scenery","sailboat","low-poly","age-of-mcp","future","water"],
  summary: "A single-masted sailboat — wind-powered coastal and river transport.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.6,
  parts: () => [
      { geometry: new THREE.OctahedronGeometry(0.3, 0), color: "#7a4f2c", position: [0, 0.14, 0], scale: [2.4, 0.7, 1.05] },
      { geometry: new THREE.ConeGeometry(0.15, 0.4, 6), color: "#7a4f2c", position: [0.66, 0.14, 0], rotation: [0, 0, -1.570796], scale: [1, 1, 0.7] },
      { geometry: new THREE.TorusGeometry(0.3, 0.024, 4, 14), color: "#553620", position: [0, 0.22, 0], rotation: [1.570796, 0, 0], scale: [2.3, 1, 1] },
      { geometry: new THREE.BoxGeometry(1, 0.03, 0.3), color: "#a07b4a", position: [0, 0.22, 0] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.022, 0.95, 6), color: "#c2a878", position: [-0.02, 0.69, 0] },
      { geometry: new THREE.CylinderGeometry(0.014, 0.014, 0.5, 5), color: "#c2a878", position: [-0.2, 0.32, 0], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.ConeGeometry(0.26, 0.78, 3), color: "#eceadf", position: [-0.16, 0.64, 0.01], rotation: [1.570796, 0, 0.06], scale: [1, 0.06, 1] },
      { geometry: new THREE.ConeGeometry(0.24, 0.74, 3), color: "#d3d0c2", position: [-0.16, 0.64, -0.02], rotation: [1.570796, 0, 0.06], scale: [1, 0.06, 1] },
      { geometry: new THREE.ConeGeometry(0.18, 0.56, 3), color: "#eceadf", position: [0.22, 0.56, 0], rotation: [1.570796, 0, -0.5], scale: [1, 0.05, 1] },
    ],
  animations: [],
});
